import type { ReactNode } from "react";

export function PageFrame({ children }: { children: ReactNode }) {
  return <div className="mx-auto flex min-w-0 w-full max-w-[1540px] flex-col gap-5 px-5 py-5 lg:px-7">{children}</div>;
}
